/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Chat_Title_LabelInputs */



/**
* | output |
* | --- |
* | "Chat title" |
*
* @param {Assistant_Chat_Title_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_chat_title_label = /** @type {((inputs?: Assistant_Chat_Title_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Chat_Title_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre du chat")
	if (locale === "de") return /** @type {LocalizedString} */ ("Chattitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Titolo della chat")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название чата")
	if (locale === "es") return /** @type {LocalizedString} */ ("Título del chat")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("聊天标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チャットタイトル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चैट शीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Título do chat")
	return /** @type {LocalizedString} */ ("Chat title")
});